function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { useAction } from 'hooks';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../../components/DownloadDataModal/DownloadDataModal.pcss';
const useIsDownloaderAppCloseNeeded = ()=>{
    const status = useSelector(selectors.status);
    return status === constants.DOWNLOADER_STATUSES.UPDATE_ENDPOINT_NOT_FOUND;
};
const Actions = ({ onSetComponent })=>{
    const isDownloaderAppCloseNeeded = useIsDownloaderAppCloseNeeded();
    const updateDownloader = useAction(actions.updateDownloader);
    const onUpdate = ()=>{
        if (isDownloaderAppCloseNeeded) {
            onSetComponent('Initializing');
            return;
        }
        updateDownloader();
    };
    useEffect(()=>{
        onUpdate();
    }, []);
    return null;
};
const UpdateError = ({ onSetComponent, onSetHeaderMessage })=>{
    const logEvent = useAction(actions.logEvent, 'UpgradePromptDisplayed');
    useEffect(()=>{
        onSetHeaderMessage(messages.downloaderOutdated.updateErrorHeader);
        logEvent();
        return ()=>onSetHeaderMessage();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.updateError,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.updateError__info, 'mb-6'),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.downloaderOutdated.updateErrorInfo))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.updateError__info,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.downloaderOutdated.updateErrorInfo2))
                    }),
                    /*#__PURE__*/ _jsx("ol", {
                        className: styles.updateError__steps,
                        children: Object.keys(messages.downloaderOutdated.updateErrorSteps).map((key)=>/*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.downloaderOutdated.updateErrorSteps[key]))
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Actions, {
                onSetComponent: onSetComponent
            })
        ]
    });
};
export default UpdateError;
